export enum DeviceType {
  Android = 'android',
  Ios = 'ios'
}
